import { render } from "./SuggestionDropdown.vue?vue&type=template&id=fea9ce80&scoped=true"
import script from "./SuggestionDropdown.vue?vue&type=script&lang=js"
export * from "./SuggestionDropdown.vue?vue&type=script&lang=js"

import "./SuggestionDropdown.vue?vue&type=style&index=0&id=fea9ce80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fea9ce80"]])

export default __exports__